module.exports = __webpack_public_path__ + "static/media/cancel-project.4ccdd18c.svg";